<template>
  <!-- CYB_PC_PR_01_00 -->
  <AlertPopup
    id="CYB_PC_PR_01_00__03"
    ref="CYB_PC_PR_01_00__03"
    size="type-large"
  >
    <template #content>
      <div class="text-wrap">
        <p class="text">
          {{ data.matnr }}은 {{ setId }} <br />
          구성 제품입니다. <br />
          SET제품으로 추가하시겠습니까?
        </p>
      </div>
    </template>
    <template #buttons>
      <div class="c-btn-area type-full">
        <button
          type="button"
          class="c-button type-secondary"
          @click="handleConfirm(CYB_PC_PR_01_00__03, false)"
        >
          <span>개별제품추가</span>
        </button>
        <button
          type="button"
          class="c-button type-primary"
          @click="handleConfirm(CYB_PC_PR_01_00__03, true)"
        >
          <span>SET제품추가</span>
        </button>
      </div>
    </template>
  </AlertPopup>
</template>

<script setup>
import { defineExpose, ref } from "vue";
import AlertPopup from "@/components/paintpro/common/alert.vue";

const CYB_PC_PR_01_00__03 = ref(null);
const data = ref(null);
const setId = ref(null);
let resolvePromise = null; // 부모에게 결과를 전달할 resolve 함수

const handleConfirm = (refName, confirm) => {
  refName.closePopup();
  resolvePromise(confirm);
};

const showAlert = (item, id) => {
  data.value = item;
  setId.value = id;
  CYB_PC_PR_01_00__03.value.openPopup();

  // Promise 반환하여 부모에서 결과를 기다리도록 함
  return new Promise((resolve) => {
    resolvePromise = resolve; // resolve를 부모에게 전달
  });
};

defineExpose({
  showAlert,
});
</script>
